import React, { useState, useRef, useCallback, useEffect } from 'react';

import MenuLateralLeft from './Menu/MenuLateralLeft.js';
import MenuLateralRight from './Menu/MenuLateralRight.js';
import TagGroup from './Form/TagGroup.js';
import '../MenuEditar.css';


const MenuEditor = () => {
  const [showModal, setShowModal] = useState(false);
  const [customLink, setCustomLink] = useState({ text: '', valueGroup: [], url: 'https://', target: '_self' });
  const [notification, setNotification] = useState(null);
  const [itemCount, setItemCount] = useState(0);
    const [availableItems] = useState([
    { id: 'page-home', title: 'Inicio', type: 'page', icon: 'file', url: '/' },
    { id: 'page', title: 'Paginas', type: 'page', icon: 'file', url: '#' },
    { id: 'catogory', title: 'Categorias', type: 'category', icon: 'folder', url: '#' },
    { id: 'products', title: 'Productos', type: 'Productos', icon: 'folder', url: '#' },
    { id: 'transversal', title: 'Transversales', type: 'transversal', icon: 'folder', url: '#' },
    { id: 'custom-link', title: 'Enlace externo', type: 'custom', icon: 'link', url: '#', valueGroup: [] }
  ]);

  const [paginas, setPaginas] = useState(
    {
      category : typeof(window.Listcategory) !== undefined ? [] : window.Listcategory,
      transversal : typeof(window.Listtransversal) !== undefined ? [] : window.Listtransversal,
      Productos : [],
      page : [
        //{ id: 'page-home', title: 'Inicio', type: 'page', icon: 'file', url: '/' },
        { id: 'page-quienes-somos', title: 'Quienes somos', type: 'page', icon: 'file', url: '/quienes-somos' },
        { id: 'page-preguntas-frecuentes', title: 'Preguntas frecuentes', type: 'page', icon: 'file', url: '/preguntas-frecuentes' },
        { id: 'terminos-condiciones', title: 'Terminos y condiciones', type: 'page', icon: 'file', url: '/terminos-condiciones' },
        { id: 'politica-de-privacidad', title: 'Politica de Privacidad', type: 'page', icon: 'file', url: '/politica-de-privacidad' },
        { id: 'politicas-de-cookies', title: 'Politica de cookies', type: 'page', icon: 'file', url: '/politicas-de-cookies' },
        { id: 'libro-de-reclamaciones', title: 'Libro de Reclamaciones', type: 'page', icon: 'file', url: '/libro-de-reclamaciones' },
        { id: 'contacto', title: 'Contacto', type: 'page', icon: 'file', url: '/contacto' },
        //{ id: 'cat-news', title: 'Noticias', type: 'category', icon: 'folder', url: '/category/news' },
        { id: 'cat-products', title: 'Productos', type: 'category', icon: 'folder', url: '/category/products' },
        { id: 'custom-link', title: 'Enlace externo', type: 'custom', icon: 'link', url: '#', valueGroup: [] }
      ]
    }
  );

  const [showListAvailable, setShowListAvailable] = useState("");

  const [menuItems, setMenuItems] = useState([]);

  const dragSourceRef = useRef({
    element: null,
    id: null,
    parentId: null,
    index: -1
  });



const updateBlockSelectBloqueAgrupado = (e, newTitle) => {
  const option = e.target.selectedOptions[0];
  const link = option.dataset.link;

  const new_item = { 
    code: newTitle, 
    title: option.text, 
    link: link 
  };

  if (newTitle !== "" && newTitle!="0") {

    console.log(newTitle)

    setCustomLink(prev => {
      const newValueGroup = [...prev.valueGroup, new_item]; // ✅ copia real

      const linkPrint = newValueGroup
        .map(p => p.link.replace(/\/c\//g, ""))
        .toString();

      return {
        ...prev,                  // ✅ copia objeto
        valueGroup: newValueGroup,
        url: "/agrupado/"+linkPrint
      };
    });

  }
};


  // Encontrar item y su padre
  const findItemAndParent = (items, targetId, parent = null) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === targetId) {
        return { item: items[i], parent, index: i };
      }
      if (items[i].children && items[i].children.length > 0) {
        const result = findItemAndParent(items[i].children, targetId, items[i]);
        if (result) return result;
      }
    }
    return null;
  };

  // Mover item a nueva posición
  const moveItem = (sourceId, targetId, position, asSubmenu = false) => {
    if (sourceId === targetId) return;

    // Encontrar source y target
    const sourceInfo = findItemAndParent(menuItems, sourceId);
    const targetInfo = findItemAndParent(menuItems, targetId);

    if (!sourceInfo || !targetInfo) return;

    // Crear copia profunda del array
    const newItems = structuredClone(menuItems);

    // Encontrar los mismos elementos en la copia
    const newSourceInfo = findItemAndParent(newItems, sourceId);
    const newTargetInfo = findItemAndParent(newItems, targetId);

    // Extraer el elemento source
    const [movedItem] = newSourceInfo.parent 
      ? newSourceInfo.parent.children.splice(newSourceInfo.index, 1)
      : newItems.splice(newSourceInfo.index, 1);

    if (asSubmenu) {
      // Mover como submenú
      if (!newTargetInfo.item.children) {
        newTargetInfo.item.children = [];
      }
      newTargetInfo.item.children.push(movedItem);
    } else {
      // Mover a posición (antes/después)
      const targetArray = newTargetInfo.parent 
        ? newTargetInfo.parent.children 
        : newItems;

      let insertIndex = newTargetInfo.index;
      if (position === 'after') {
        insertIndex++;
      }

      targetArray.splice(insertIndex, 0, movedItem);
    }

    setMenuItems(newItems);
  };

  // Handlers nativos de drag and drop
  const handleDragStart = (e, itemId) => {
    e.dataTransfer.setData('text/plain', itemId);
    e.dataTransfer.effectAllowed = 'move';
    
    // Guardar referencia del elemento arrastrado
    dragSourceRef.current = {
      element: e.target.closest('.menu-item'),
      id: itemId,
      parentId: e.target.closest('.menu-item')?.parentElement?.id || null,
      index: Array.from(e.target.closest('.menu-item').parentNode.children).indexOf(e.target.closest('.menu-item'))
    };
    
    // Añadir clase para feedback visual
    e.target.closest('.menu-item').classList.add('dragging');
  };

  const handleDragOver = (e, targetId) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    
    const targetElement = e.currentTarget;
    const rect = targetElement.getBoundingClientRect();
    const mouseY = e.clientY;
    const threshold = rect.height * 0.3;

    // Limpiar clases previas
    targetElement.classList.remove('drag-before', 'drag-after', 'drag-submenu');

    // Detectar si es para submenú (con Ctrl)
    if (e.ctrlKey || e.shiftKey) {
      targetElement.classList.add('drag-submenu');
    } else {
      // Detectar posición (antes/después)
      if (mouseY < rect.top + threshold) {
        targetElement.classList.add('drag-before');
      } else if (mouseY > rect.bottom - threshold) {
        targetElement.classList.add('drag-after');
      }
    }
  };

  const handleDragLeave = (e) => {
    e.currentTarget.classList.remove('drag-before', 'drag-after', 'drag-submenu');
  };

  const handleDrop = (e, targetId) => {
    e.preventDefault();
    
    // Obtener ID del elemento arrastrado
    const sourceId = e.dataTransfer.getData('text/plain');
    
    // Limpiar clases
    e.currentTarget.classList.remove('drag-before', 'drag-after', 'drag-submenu');
    document.querySelectorAll('.menu-item').forEach(el => {
      el.classList.remove('dragging');
    });

    if (!sourceId || sourceId === targetId) return;

    // Determinar posición y tipo de movimiento
    const rect = e.currentTarget.getBoundingClientRect();
    const mouseY = e.clientY;
    const threshold = rect.height * 0.3;
    
    const asSubmenu = e.ctrlKey || e.shiftKey;
    
    let position = 'after';
    if (!asSubmenu) {
      if (mouseY < rect.top + threshold) {
        position = 'before';
      }
    }

    // Mover el item
    moveItem(sourceId, targetId, position, asSubmenu);
  };

  const handleDragEnd = (e) => {
    e.currentTarget.classList.remove('dragging');
    document.querySelectorAll('.menu-item').forEach(el => {
      el.classList.remove('drag-before', 'drag-after', 'drag-submenu');
    });
  };



  // Componente recursivo para items del menú
  const MenuItem = ({ item, level = 0 }) => {
    return (
      <div
        className="menu-item"
        data-id={item.id}
        data-type={item.type}
        draggable="true"
        onDragStart={(e) => handleDragStart(e, item.id)}
        onDragOver={(e) => handleDragOver(e, item.id)}
        onDragLeave={handleDragLeave}
        onDrop={(e) => handleDrop(e, item.id)}
        onDragEnd={handleDragEnd}
      >
        <div className="menu-item-header">
          <span className="menu-item-drag">
            <i className="fas fa-grip-vertical"></i>
          </span>
          <span className="menu-item-title">{item.title}</span>
          <span className="menu-item-type">{item.type.toUpperCase()}</span>
        </div>

        {item.children && item.children.length > 0 && (
          <div className="submenu-container">
            {item.children.map(child => (
              <MenuItem key={child.id} item={child} level={level + 1} />
            ))}
          </div>
        )}
      </div>
    );
  };

  const getApiDataCategory = async () => {
    const response = await fetch(window.path_service_website+"/categoria/list/menu_minimal",{method:'POST'})    
    const data = await response.json()

      try {
        window.Listcategory = data.data
      } catch (e) {
        console.error("Error cargando menú:", e);
      }

  };

  const getApiDataTransversal = async () => {
    const response = await fetch(window.path_service_website+"/api/page/list/transversal_minimal",{method:'POST'})    
    const data = await response.json()

      try {
        window.Listtransversal = data.data
      } catch (e) {
        console.error("Error cargando menú:", e);
      }

  };

  const getApiDataInitial = async () => {
    const response = await fetch(window.path_service_website+"/aux/api/list/pages",{method:'POST',body:  JSON.stringify({id_comercio: 4 , vista: "menu"}) })
    const data = await response.json()

      try {
        setMenuItems(data.data.data_raw);
      } catch (e) {
        console.error("Error cargando menú:", e);
      }

  };

  useEffect(() => {
    getApiDataInitial();
    getApiDataCategory();
    getApiDataTransversal();

  }, []);


  const updateItemTitle = (itemId, newTitle) => {
    const updateItems = (items) => {
      return items.map(item => {
        if (item.id === itemId) {
          return { ...item, title: newTitle };
        }
        if (item.children && item.children.length > 0) {
          return {
            ...item,
            children: updateItems(item.children)
          };
        }
        return item;
      });
    };
    
    setMenuItems(updateItems(menuItems));
  };

  const updateItemUrl = (itemId, newUrl) => {
    console.log(itemId,newUrl)
    const updateItems = (items) => {
      return items.map(item => {
        if (item.id === itemId) {
          return { ...item, url: newUrl };
        }
        if (item.children && item.children.length > 0) {
          return {
            ...item,
            children: updateItems(item.children)
          };
        }
        return item;
      });
    };
    
    setMenuItems(updateItems(menuItems));
  };

  const returnListInitial  = (availableItem) => {
    setShowListAvailable("")
  };

  const callsetpaginas = (paginas) => {
    setPaginas(paginas)
  };

  const addChild = (parentId, newChild) => {
    const addRecursive = (items) => {
      return items.map(item => {
        if (item.id === parentId) {
          return {
            ...item,
            children: [...item.children, newChild]
          };
        }

        if (item.children?.length) {
          return {
            ...item,
            children: addRecursive(item.children)
          };
        }

        return item;
      });
    };

    setMenuItems(prev => addRecursive(prev));
  };


  const onAddSubmenu = (item) => {
    console.log("onAddSubmenu",item,menuItems)

    const newItem = {
          id: generateId(),
          title: "Nuevo elemento",
          type: "custom",
          icon: "link",
          url: "",
          expanded: false,
          children: [],
          imageFile: null,
          imagePreview: null,
          imageName: null,
          internalCode : 0

        };

    addChild(item,newItem)

    /*

    let itemSafeSubmenu = menuItems.filter(function(val) {
            return val.id === item
        })    
    

        if (itemSafeSubmenu.length > 0 ) {
          itemSafeSubmenu = itemSafeSubmenu[0]

          itemSafeSubmenu.children = !Array.isArray(itemSafeSubmenu.lista) ? [] : itemSafeSubmenu.children;
          console.log(itemSafeSubmenu);

          itemSafeSubmenu.children.push(newItem);

          console.log(itemSafeSubmenu);
        }




        //setMenuItems([...menuItems, newItem]);

        //showNotification(`"${availableItem.title}" añadido al menú`);

    */
  };


  const onEdit = (item) => {
    console.log("edit",item)
  };

  const onDelete = (item) => {
      window.Swal.fire({
        title: 'Eliminar Producto',
        text: '¿Esta seguro de querer eliminarlo?',
        icon: 'error',
        showCancelButton: true,
        cancelButtonColor: "#666",
        confirmButtonColor: "#13a538",
        confirmButtonText: 'Si',
        cancelButtonText: "No"
      }).then((result) => {
        if (result.isConfirmed) {
          deleteItem(item)
          console.log("onAddSubmenu",item)
        }
      })     
  };    

  const deleteItem =(item) =>{
    let contactsSafe = menuItems.filter(function(val) {
        return val.id != item
    })    

    //handleCuentaBancaria(contactsSafe)
    console.log(menuItems)
    console.log("post eliminar",contactsSafe,item)
    setMenuItems(contactsSafe)

    window.Swal.fire({
            icon: 'success',
            title: "Se elimino correctamente",
            showConfirmButton: false,
            timer: 2500
    });   

  }

  const callsetMenuItems = (items) => {
    setMenuItems(items)
  };  
  

  const generateId = () => {
    return 'item_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  };

  console.log(menuItems)
  
  const addToMenuFromAvailable = (availableItem) => {

    let vinternalCode = 0;
    if (["category","transversal"].includes(availableItem.type)) {
      vinternalCode = availableItem.code_backoffice;
    }

    const newItem = {
      id: generateId(),
      title: availableItem.title,
      type: availableItem.type,
      icon: availableItem.icon,
      url: availableItem.url,
      expanded: false,
      children: [],
      imageFile: null,
      imagePreview: null,
      internalCode : vinternalCode,
      imageName: null

    };
    
    setMenuItems([...menuItems, newItem]);
    showNotification(`"${availableItem.title}" añadido al menú`);
  };

  const getIconComponent = (iconName) => {
    switch(iconName) {
      case 'file': return ;
      case 'folder': return ;
      case 'link': return ;
      default: return ;
    }
  };


  const uploadApiImageService = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    const res = await fetch(window.path_service_website+"/aux/api/file", {
      method: "POST",
      body: formData
    });

    const data = await res.json();

    console.log(data,data.url)

    // respuesta esperada:
    // { url: "https://cdn.miapp.com/images/abc.png" }

    return data.url;
  };

  const processImagesTree = async (items) => {
    const newItems = [];

    for (const item of items) {
      let newItem = { ...item };

      // 🔥 Si tiene imagen local
      console.log(newItem.imageFile,item.title)
      if (newItem.imageFile instanceof File) {
        const url = await uploadApiImageService(newItem.imageFile);

        newItem.imageFile = url;      // ahora es string
        newItem.imagePreview = url;   // preview remoto
        newItem.imageName = newItem.imageName || newItem.imageFile.name;
      }

      console.log("new sub menu",newItem)
      // ⬇️ Procesar hijos recursivamente
      
      /*
       //no debe estar disponible
      if (newItem.children?.length) {
        newItem.children = await processImagesTree(newItem.children);
      }
      */

      newItems.push(newItem);
    }

    return newItems;
  };


  const saveMenu = async(event) =>{
    var modaLoading = 
      window.Swal.fire({
        imageUrl: window.path_service+'/images/loading.png',
        title: 'Cargando datos...',
        showConfirmButton: false,
        customClass: 'ms-loading-modal',
          allowOutsideClick: false
      });
            
      if ( ![undefined,"undefined",""].includes(localStorage.token_authlead) ) {

        const processedMenu = await processImagesTree(menuItems);

        const bodyjson = {
          id_comercio : 4,
          name: "Menu Principal",
          vista : "menu",
          body : processedMenu
        };

        const response = await fetch(window.path_service_website+"/aux/api/save/pages",{method:'POST',body:  JSON.stringify(bodyjson) })
        const data = await response.json()

        if ( data.hasOwnProperty("status") && data.status ) {
              //document.cookie='commerce_lead_token='+data.lead_token;

              window.Swal.fire({
                  icon: 'success',
                  title: data.message,
                  showConfirmButton: false,
                  timer: 2500
                });                   
          //window.location.href = "/confirmacion?process=finish&checkout=simple&orden="+id_orden;
          modaLoading.close();
        }else{
            window.Swal.fire({
                  icon: 'error',
                  title: data.message,
                  showConfirmButton: false,
                  timer: 3500
            }); 
            modaLoading.close();          
        }
        

      }     
    
  }
  const addToListValuesFromAvailable = (availableItem) => {
    if ( (["page-home","custom-link"]).includes(availableItem.id) ) {
        const newItem = {
          id: generateId(),
          title: availableItem.title,
          type: availableItem.type,
          icon: availableItem.icon,
          url: availableItem.url,
          expanded: false,
          children: [],
          imageFile: null,
          imagePreview: null,
          imageName: null,
          internalCode : 0,
          valueGroup: availableItem.hasOwnProperty("valueGroup") ? availableItem.valueGroup : []
        };

        setMenuItems([...menuItems, newItem]);

        showNotification(`"${availableItem.title}" añadido al menú`);

    }else{
      console.log(availableItem,paginas.hasOwnProperty(availableItem.type),availableItem.type)
      setShowListAvailable(availableItem.type)
    }
    
  };

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 2000);
  };


  const addCustomLink = () => {
    if (!customLink.text || !customLink.url) {
      alert('Completa todos los campos');
      return;
    }
    
    const newItem = {
      id: generateId(),
      title: customLink.text,
      type: 'custom',
      icon: 'link',
      url: customLink.url,
      target: customLink.target,
      expanded: false,
      children: [],
      imageFile: null,
      imagePreview: null,
      imageName: null,
      internalCode : 0,
      valueGroup: customLink.hasOwnProperty("valueGroup") ? customLink.valueGroup : []
    };
    
    setMenuItems([...menuItems, newItem]);
    setShowModal(false);
    setCustomLink({ text: '', valueGroup: [], url: 'https://', target: '_self' });
    showNotification('Enlace personalizado añadido');
  };

  return (
    <div className="wp-menu-editor">

      <div className="wp-container">
        {/* Toolbar */}
        <div className="wp-toolbar">
          <button className="wp-button" onClick={() => setShowModal(true)}>
             Añadir enlace personalizado
          </button>
          <button className="wp-button wp-button-secondary" onClick={() => setShowModal(true)}>
            Añadir Agrupación
          </button>
        </div>


        {/* Main editor */}
        <div className="wp-editor-grid">
          {/* Panel izquierdo - Elementos disponibles */}
          
          <MenuLateralLeft
            showListAvailable = {showListAvailable}
            paginas = {paginas}
            returnListInitial ={returnListInitial}
            addToMenuFromAvailable = {addToMenuFromAvailable}
            addToListValuesFromAvailable = {addToListValuesFromAvailable}
            getIconComponent = {getIconComponent}
           />

          <MenuLateralRight
            showListAvailable = {showListAvailable}
            itemCount = {itemCount}
            notification = {notification}
            saveMenu = {saveMenu}
            menuItems ={menuItems}
            callsetMenuItems = {callsetMenuItems}
            addToListValuesFromAvailable = {addToListValuesFromAvailable}
            getIconComponent = {getIconComponent}
            updateItemUrl = {updateItemUrl}
            dragSourceRef ={dragSourceRef}
            handleDragStart ={handleDragStart}
            handleDragOver = {handleDragOver}
            handleDragLeave = {handleDragLeave}
            handleDrop = {handleDrop}
            handleDragEnd = {handleDragEnd}            
            onAddSubmenu={onAddSubmenu}
            onEdit={onEdit}
            updateItemTitle = {updateItemTitle}
            onDelete={onDelete}
           />
          
          


        </div>



        
        </div>
      
      {showModal && (
        <div className="wp-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Añadir enlace personalizado</h3>
              <button className="close-btn" onClick={() => setShowModal(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="field-group">
                <label>Texto del enlace</label>
                <input
                  type="text"
                  value={customLink.text}
                  onChange={(e) => setCustomLink({...customLink, text: e.target.value})}
                  placeholder="Ej: Nuestros servicios"
                />
              </div>


              <div className="field-group">
                <label>Lista de Categorias:</label>
                <select 
                onChange={(e) => updateBlockSelectBloqueAgrupado(e, e.target.value)}
                >
                  <option value="0">Seleccione un item</option>
                        {
                          window.Listcategory.map((entry,enkey) =>
                            <option key={enkey} data-link={entry.url} value={entry.code_backoffice}>{entry.title}</option>
                          )
                        }              
                </select>


<TagGroup
  items={customLink.valueGroup}
  onRemove={(index) => {
    setCustomLink(prev => {
      const newGroup = prev.valueGroup.filter((_, i) => i !== index);

      const linkPrint = newGroup
        .map(p => p.link.replace(/\/c\//g, ""))
        .toString();

      return {
        ...prev,
        valueGroup: newGroup,
        url: linkPrint
      };
    });
  }}
/>
              </div>     
              

              <div className="field-group">
                <label>URL</label>
                <input
                  disabled
                  type="text"
                  value={customLink.url}
                  onChange={(e) => setCustomLink({...customLink, url: e.target.value})}
                  placeholder="https://ejemplo.com"
                />
              </div>

              <div className="field-group">
                <label>Abrir enlace en</label>
                <select
                  value={customLink.target}
                  onChange={(e) => setCustomLink({...customLink, target: e.target.value})}
                >
                  <option value="_self">Misma ventana</option>
                  <option value="_blank">Nueva ventana</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button className="wp-button wp-button-secondary" onClick={() => setShowModal(false)}>
                Cancelar
              </button>
              <button className="wp-button" onClick={addCustomLink}>
                Añadir al menú
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default MenuEditor;